// 앱 루트 — 인증 상태에 따라 로그인 화면/공통 레이아웃을 전환 (라우터 없음)
import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ChatProvider } from './context/ChatContext';
import Layout from './components/Layout/Layout';
import LayoutZeirishi from './components/Layout/Layout.zeirishi';
import { usePortal } from './lib/portal';
import LoginPage from './pages/Login/LoginPage';
import SessionExpiredDialog from './components/SessionExpiredDialog';
import AffiliationChangedNotice from './components/AffiliationChangedNotice';

function Shell() {
  const { isAuthenticated, initializing } = useAuth();
  /* 포털마다 껍데기가 다르다 — 세리사무소는 화이트라벨 상단바와 우측 레일을 쓴다.
     호스트 Layout 에 분기를 넣지 않고 여기서 고르는 이유: 기본 포털 코드가
     세리사무소 사정으로 흔들리지 않게 하려는 것이다. */
  const portal = usePortal();

  if (initializing) {
    // 세션 복구 중 깜빡임 방지용 최소 로딩 상태
    return null;
  }

  // 채팅 상태는 로그인 이후 화면(홈)에서만 쓰므로 Layout만 감싼다
  return (
    <>
      {isAuthenticated ? (
        <ChatProvider>
          {portal === 'zeirishi' ? <LayoutZeirishi /> : <Layout />}
        </ChatProvider>
      ) : (
        <LoginPage />
      )}
      {/* 세션 만료 안내는 로그인 화면 위에 떠야 하므로 분기 밖에 둔다 */}
      <SessionExpiredDialog />
      {/* 다른 창에서 회사가 바뀐 경우 — 일반·세리사무소 두 껍데기 모두에 필요해 분기 밖에 둔다 */}
      {isAuthenticated && <AffiliationChangedNotice />}
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  );
}
